function megaMenuHover() {
  const selectors = {
    megaMenuListItems: document.querySelectorAll('.mega-menu__link'),
    megaMenuListImages: document.querySelectorAll('.mega-menu__image')
  }

  // Curent active
  let activeImage = document.querySelector('.mega-menu__image.mega-menu__image--hover'),
      activeMenuItem = document.querySelector('.mega-menu__link.mega-menu__link--hover'),
      activeSubMenu = document.querySelector('.mega-menu__child-list.mega-menu__child-list--hover');
  
  /*function changeImage(event) {
    activeImage.classList.remove('mega-menu__image--hover');
    let imageKey = menuItem.getAttribute('data-mega-menu-image');
    let imgElement = document.querySelector(`.mega-menu__image[data-mega-menu-image=${imageKey}]`);
    activeImage = imgElement;
    imgElement.classList.add('mega-menu__image--hover');
  }*/

  selectors.megaMenuListItems.forEach((item) => {
    let parentItem = false;
    if (item.parentElement.querySelector('.mega-menu__child-list')) {
      parentItem = true;
    }

    item.addEventListener('mouseover', (e) => {
      // Remove current active
      if (activeMenuItem && activeMenuItem !== e.target) {
          activeImage.classList.remove('mega-menu__image--hover');
        if (!parentItem) {
          activeMenuItem.classList.remove('mega-menu__link--hover');
        } 
        if (parentItem && e.target.closest('.mega-menu__child-list--hover') === null) {
          activeMenuItem.classList.remove('mega-menu__link--hover');
        } 
        if (activeSubMenu && e.target.closest('.mega-menu__child-list--hover') === null) {
          activeSubMenu.classList.remove('mega-menu__child-list--hover');
        }
      }

      // Assign new current active
      let menuElement = e.target.closest('.mega-menu__link');
      let imageKey = menuElement.getAttribute('data-mega-menu-image');
      let imgElement = document.querySelector(`.mega-menu__image[data-mega-menu-image=${imageKey}]`);

      activeMenuItem = menuElement;
      activeImage = imgElement;
      
      imgElement.classList.add('mega-menu__image--hover');
      menuElement.classList.add('mega-menu__link--hover');

      if (parentItem) {
        let subMenu = e.target.parentElement.querySelector('.mega-menu__child-list');
        activeSubMenu = subMenu;
        subMenu.classList.add('mega-menu__child-list--hover');
      }
    });
  });
}

megaMenuHover();